import { createContext, type Dispatch, type SetStateAction } from 'react';

export interface SinglePopover {
  id: string;
  keepOpen: boolean;
}

export interface PopoverContextValue {
  setOpenedPopovers: Dispatch<SetStateAction<SinglePopover[]>>;
  openedPopovers: SinglePopover[];
}

const PopoverContext = createContext<PopoverContextValue>({
  setOpenedPopovers: () => {},
  openedPopovers: [],
});

export default PopoverContext;
